import { showHide } from "./showHide";
import { isHiddenWithinTree } from "./utils/isHiddenWithinTree";

export const toggle = (element: HTMLElement, show?: boolean) => {
  if (typeof show === "boolean") {
    return show ? showHide(element, true) : showHide(element, false);
  }

  if (isHiddenWithinTree(element)) {
    showHide(element, true)
  } else {
    showHide(element, false);
  }
};